import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { ellipsisMultiline } from '@/styles/helpers';

export const Box = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
  display: grid;
  grid-template-columns: 1fr 50px;
  gap: 20px;
  border-radius: 7px;
  padding: 10px 15px;
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Main = styled.div`
  display: grid;
  grid-template-columns: 45px 1fr;
  align-items: center;
  gap: 10px;
`;

export const Name = styled(Typography.Body)`
  ${ellipsisMultiline(1)};
  margin-bottom: 5px;
`;

export const Details = styled.div`
  display: flex;
  gap: 5px;
`;

export const BankName = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const AdditionalInfo = styled(Typography.Body)<{ $isGreen: boolean }>`
  color: ${({ theme, $isGreen }) =>
    $isGreen ? theme.palette.system.green : theme.palette.system.red};
`;
